<template>
    <div class="bulma">
        <article class="media">
            <div class="media-content">
                <div class="field">
                    <p class="control">
                        <editable
                            :is-collapsed-if-empty="true"
                            @focusin="show(true)"
                            @focusout="show(false)"
                            v-model="content"
                            :placeholder="trans.textarea_placeholder"
                            @send="postComment"
                        />
                    </p>
                </div>
                <comment-send-cancel-buttons
                    v-if="isShown"
                    :trans="trans"
                    :isRequestInProgress="isRequestInProgress"
                    @isAction="isAction($event)"
                />
            </div>
        </article>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";

import Editable from "../../Editable";
import CommentSendCancelButtons from "./CommentSendCancelButtons";

export default {
    name: "NewComment",
    components: {
        Editable,
        CommentSendCancelButtons,
    },
    data() {
        return {
            content: null,
            isShown: false,
        }
    },
    computed: {
        ...mapState('comment', [
            'trans',
        ]),
        ...mapGetters('comment', [
            'isRequestInProgress',
            'documentHash',
        ]),
        isCommentEmpty() {
            return this.content !== '' && this.content !== null;
        },
    },
    methods : {
        ...mapActions('comment', [
            'addComment',
            'setRequestInProgress',
            'showCommentErrorDocumentDeletedModal',
        ]),
        postComment() {
            this.setRequestInProgress(true);

            this.addComment(this.content)
                .then(response => {
                    this.content = '';
                })
                .catch(error => {
                    if (error.response.status === 404) {
                        this.showCommentErrorDocumentDeletedModal(true);
                    }

                    this.showNotification(error.response.data.errors.body[0], 680);
                })
                .finally(() => {
                    this.setRequestInProgress(false);
                });
        },
        show(value) {
            value ? this.isShown = true : (this.content === null || this.content === '') ? this.isShown = false : this.isShown = true;
        },
        isAction(value) {
            !value ? (this.content = '', this.isShown = false) : (this.postComment(), this.isShown = false);
        },
    },
    watch: {
        documentHash(newValue, oldValue) {
            (this.content = '', this.isShown = false);
        },
    },
}
</script>

<style lang="scss" scoped>
    .field {
        width: calc(100% - 2px);
        max-width: calc(100% - 2px);
        margin-bottom: 0rem !important;
    }
    .bulma .control {
        max-width: calc(100% - 2px);
    }
</style>
